'use es6';

import createAction from 'flux-actions/createAction';
import { CREATED_AND_USED_IN_LIST, FETCHED_LISTS, FETCHED_SPECIFIC_LISTS, FETCHED_STATIC_LISTS, RECEIVED_LISTS, RECEIVED_SPECIFIC_LISTS, RECEIVED_STATIC_LISTS, REQUESTED_CREATE_AND_USE_IN_LIST, REQUESTED_CREATE_AND_USE_IN_LIST_FAILED, REQUESTED_CREATE_AND_USE_IN_LIST_SUCCEEDED, REQUESTED_LISTS, REQUESTED_LISTS_FAILED, REQUESTED_SPECIFIC_LISTS, REQUESTED_SPECIFIC_LISTS_FAILED, REQUESTED_STATIC_LISTS, REQUESTED_STATIC_LISTS_FAILED, REQUESTED_USE_IN_LIST, REQUESTED_USE_IN_LIST_FAILED, REQUESTED_USE_IN_LIST_SUCCEEDED, UPDATE_LISTS_FOR_CONTENT, USED_IN_LIST } from './ActionTypes';
import { createTranslatedDangerNotification, createTranslatedSuccessNotification } from '../utils/alertUtils';
import { getUsageTrackerMeta } from '../utils/usageTracker';
export const requestLists = createAction(REQUESTED_LISTS);
export const receiveLists = createAction(RECEIVED_LISTS, lists => ({
  lists
}));
export const requestedListsFailed = createAction(REQUESTED_LISTS_FAILED, error => ({
  error
}));
export const fetchLists = createAction(FETCHED_LISTS, ({
  offset,
  search
}) => ({
  offset,
  search
}));
export const requestStaticLists = createAction(REQUESTED_STATIC_LISTS);
export const receiveStaticLists = createAction(RECEIVED_STATIC_LISTS, lists => ({
  lists
}));
export const requestedStaticListsFailed = createAction(REQUESTED_STATIC_LISTS_FAILED, error => ({
  error
}));
export const fetchStaticLists = createAction(FETCHED_STATIC_LISTS, ({
  offset,
  search
}) => ({
  offset,
  search
}));
export const requestSpecificLists = createAction(REQUESTED_SPECIFIC_LISTS);
export const receiveSpecificLists = createAction(RECEIVED_SPECIFIC_LISTS, lists => ({
  lists
}));
export const requestedSpecificListsFailed = createAction(REQUESTED_SPECIFIC_LISTS_FAILED, error => ({
  error
}));
export const fetchSpecificLists = createAction(FETCHED_SPECIFIC_LISTS, listIds => ({
  listIds
}));
export const useInList = createAction(USED_IN_LIST, ({
  contentType,
  data,
  listId
}) => ({
  contentType,
  data,
  listId
}));
export const requestUseInList = createAction(REQUESTED_USE_IN_LIST);
export const requestedUseInListSuccess = createAction(REQUESTED_USE_IN_LIST_SUCCEEDED, lists => ({
  lists
}), (contentType, href) => Object.assign({}, createTranslatedSuccessNotification(contentType, 'useInList', {
  href
}), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'useInList',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestedUseInListFailure = createAction(REQUESTED_USE_IN_LIST_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'useInList', error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'useInList',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const createAndUseInList = createAction(CREATED_AND_USED_IN_LIST, ({
  contentType,
  data,
  name
}) => ({
  contentType,
  data,
  name
}));
export const requestCreateAndUseInList = createAction(REQUESTED_CREATE_AND_USE_IN_LIST);
export const requestedCreateAndUseInListSuccess = createAction(REQUESTED_CREATE_AND_USE_IN_LIST_SUCCEEDED, lists => ({
  lists
}), (contentType, href) => Object.assign({}, createTranslatedSuccessNotification(contentType, 'createAndUseInList', {
  href
}), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'create-and-use-in-list',
  'page-type': contentType,
  screen: 'detail',
  status: 'success'
})));
export const requestedCreateAndUseInListFailure = createAction(REQUESTED_CREATE_AND_USE_IN_LIST_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'createAndUseInList', error), getUsageTrackerMeta('contentActionsInteraction', {
  action: 'create-and-use-in-list',
  'page-type': contentType,
  screen: 'detail',
  status: 'fail'
})));
export const updateListsForContent = createAction(UPDATE_LISTS_FOR_CONTENT, updatedSelectedLists => ({
  updatedSelectedLists
}));